import React from 'react';
import VictoryCup from 'svg/VictoryCup';
import VictoryCupShadow from 'svg/VictoryCupShadow';

type CircularProgressBarProps = {
  currentStep: number;
  totalSteps: number;
};

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({ currentStep, totalSteps }) => {
  const newCurrentStep = currentStep - 1;
  const progress = (newCurrentStep / totalSteps) * 100;
  const radius = 50; // Radius of the circle
  const strokeWidth = 7; // Width of the stroke

  // Calculate the circumference of the circle
  const circumference = 2 * Math.PI * radius;
  // Calculate the dash offset based on the progress
  const dashOffset = circumference - (progress / 100) * circumference;

  return (
    <div className="mx-auto flex max-w-[75rem] flex-col items-center px-gutter-base">
      <div className="flex flex-grow bg-color-bg-lightmode-primary py-4 dark:bg-color-bg-darkmode-primary">
        <svg className="h-40 w-40" viewBox="0 0 120 120">
          {/* Background circle for inactive state */}
          <circle
            className="stroke-current text-color-text-darkmode-primary dark:text-color-text-lightmode-primary"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            fill="transparent"
            r={radius}
            cx={60}
            cy={60}
          />
          {/* Progress circle */}
          <circle
            className="stroke-current text-color-text-brand dark:text-color-text-brand"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            fill="transparent"
            r={radius}
            cx={60}
            cy={60}
            style={{
              transition: 'stroke-dashoffset 0.35s',
              transform: 'rotate(-90deg)',
              transformOrigin: '50% 50%',
            }}
          />
          {/* Centered VictoryCup */}
          <g transform="translate(23, 25)">
            <VictoryCup />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default CircularProgressBar;
